/**
 * @file routerHistory.js
 * Exports router history object.
 */

import createBrowserHistory from 'history/createBrowserHistory';

const history = createBrowserHistory();
export default history;



// WEBPACK FOOTER //
// ./src/lib/routerHistory.js